import Avatar from "../../../../Atoms/Avatar";
import RadioButton from "../../../../Atoms/RadioButton";
import GuideStats from "../../../../Atoms/GuideStats";
import VideoAvatar from "../../../../Atoms/VideoAvatar";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import GuideInfo from "../GuideInfo";
import { useState, useRef } from "react";
import styles from "./GuidePicker.module.scss";
import { Guide } from "../../../../../graphql/operations";

const groupPic = `https://magical-trip.s3.ap-northeast-1.amazonaws.com/images/a9a2ebd9-ced6-4793-a0cf-14488d92b03a-cb5bjfdp.jpg`;

interface Props {
  value: string | undefined;
  onChange: (value: string) => void;
  guides: Guide[];
}

export default function GuidePicker({ value, onChange, guides }: Props) {
  const [selectedGuide, setGuide] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const onOpenModal = () => setOpenModal(true);
  const onCloseModal = () => setOpenModal(false);
  const modalRef = useRef(null);
  const numberOfOptions = guides.length;

  if (numberOfOptions === 0) {
    return (
      <div className={styles.staticContainer}>
        <Avatar name={""} src={groupPic} size={88} />
        <div className={styles.mediaContent}>
          <span>Guide not decided yet</span>
        </div>
      </div>
    );
  }

  if (numberOfOptions === 1) {
    const guide = guides[0];

    return (
      <div className={styles.staticContainer}>
        {guide.introVideo ? (
          <div style={{ height: 88 }}>
            <VideoAvatar
              guideId={guide.id}
              videoPublicId={guide.introVideo}
              avatarSrc={guide.profilePic}
            />
          </div>
        ) : (
          <Avatar name={guide.nickName} size={88} src={guide.profilePic} />
        )}
        <div className={styles.mediaContent}>
          <span className="ui-Text--highlight">{guide.nickName}</span>
          <br />
          <GuideStats guideId={guide.id} />
          <p className={styles.GuideProfileLink} onClick={onOpenModal}>
            View Profile
          </p>
        </div>
        <Modal
          open={openModal}
          onClose={onCloseModal}
          ref={modalRef}
          blockScroll={false}
          initialFocusRef={modalRef}
          classNames={{
            modal: styles.CustomModal,
          }}
        >
          <GuideInfo guideId={guide.id} />
        </Modal>
      </div>
    );
  }

  return (
    <ol>
      {guides.map((guide, index) => (
        <li
          className={styles.guideListItem}
          onClick={() => {
            onChange(guide.id);
            setGuide(guide.id);
          }}
          key={index}
        >
          <div className={styles.container}>
            {guide.introVideo ? (
              <div style={{ height: 88 }}>
                <VideoAvatar
                  guideId={guide.id}
                  videoPublicId={guide.introVideo}
                  avatarSrc={guide.profilePic}
                />
              </div>
            ) : (
              <Avatar name={guide.nickName} size={88} src={guide.profilePic} />
            )}

            <div className={styles.mediaContent}>
              <span className="ui-Text--highlight">{guide.nickName}</span>
              <br />
              <GuideStats guideId={guide.id} />
              <p className={styles.GuideProfileLink} onClick={onOpenModal}>
                View Profile
              </p>
            </div>
            <div style={{ padding: "0 16px" }}>
              <RadioButton checked={value === guide.id} />
            </div>
          </div>
        </li>
      ))}
      <Modal
        open={openModal}
        onClose={onCloseModal}
        ref={modalRef}
        blockScroll={false}
        initialFocusRef={modalRef}
        classNames={{
          modal: styles.CustomModal,
        }}
      >
        <GuideInfo guideId={selectedGuide} />
      </Modal>
    </ol>
  );
}
